import script from "./EventTitle.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventTitle.vue?vue&type=script&lang=js"
export * from "./EventTitle.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/event-card/EventTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f24b23d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f24b23d', __exports__)) {
    api.reload('0f24b23d', __exports__)
  }
  
}


export default __exports__